class ProductLoveLetter extends HTMLElement {
    constructor() {
        super();
        this.lengthDisplay = null;
        this.letterCount = 0;
        this.letterSelection = null;

    }

    connectedCallback() {
        const self = this;
        const letters = this.querySelectorAll(".loveletter-swatch");
        const letterSelection = this.querySelector('.loveletter-result__selection');
        this.lengthDisplay = this.querySelector(".loveletter-result__length");
        const addToCart = this.parentElement.querySelector("#AddToCart");

        // Add event listeners for adding letters
        letters.forEach(function (letter) {
            letter.addEventListener("click", self.letterAdd.bind(self, letter));
        });

        // Add event listener for removing selected letters
        letterSelection.addEventListener("click", function (event) {
            const target = event.target;
            if (target.classList.contains('loveletter-result__selection__letter')) {
                self.letterRemove(target);
            }
        });


        // Setup a mutation observer to handle changes in the letter selection
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const selectedLetter = node.querySelector(".loveletter-result__selection__letter");
                            if (selectedLetter) {
                                selectedLetter.addEventListener("click", (event) => {
                                    // Call updateButton function with the clicked letter as a parameter
                                    self.updateButton(event.target);
                                });
                            }
                        }
                    });
                }
            });
        });

        const selectionObserver = new MutationObserver(() => {
            self.updateButton(letterSelection);
        });
        const selectionConfig = { childList: true, subtree: true };
        selectionObserver.observe(letterSelection, selectionConfig);

        const config = { childList: true, subtree: true };
        observer.observe(letterSelection, config);

        letterSelection.addEventListener("change", this.updateButton.bind(this), false);

        addToCart.addEventListener("click", this.postForm.bind(this), false);

    }



    letterAdd(letter) {

        const letterSelection = this.querySelector('.loveletter-result__selection');
        const container = this.querySelector(".loveletter-container");

        const span = document.createElement('span');
        span.classList.add('loveletter-result__selection__letter');
        span.setAttribute('data-letter', letter.getAttribute('data-letter'));
        span.setAttribute('data-id', letter.getAttribute('data-id'));
        span.setAttribute('data-price', letter.getAttribute('data-price'));
        span.textContent = letter.textContent;

        const stock = letter.getAttribute('data-stock');
        letter.setAttribute('data-stock', stock - 1);
        if (stock == 1) {
            letter.classList.add('loveletter-swatch__out-of-stock');
        }

        letterSelection.appendChild(span);

        if (this.letterCount < 9) {
            this.letterCount++;
            this.lengthDisplay.textContent = `(${this.letterCount}/10)`;
        } else {
            this.letterCount++;
            container.classList.add('full');
            this.lengthDisplay.textContent = `(${this.letterCount}/10)`;
        }

    }

    letterRemove(letter) {
        const container = this.querySelector(".loveletter-container");
        letter.remove();

        const letterId = letter.getAttribute('data-id');
        const letterSwatch = this.querySelector(`.loveletter-swatch[data-id="${letterId}"]`);
        const stock = letterSwatch.getAttribute('data-stock');
        letterSwatch.setAttribute('data-stock', parseInt(stock) + 1);
        if (stock == 0) {
            letterSwatch.classList.remove('loveletter-swatch__out-of-stock');
        }
        this.letterCount--;
        this.lengthDisplay.textContent = `(${this.letterCount}/10)`;

        if (this.letterCount < 11) {
            container.classList.remove('full');
        }
    }

    updateButton(clickedLetter) {
        const buttonAddtoCart = this.parentElement.querySelector("#AddToCart");
        const startingPrice = buttonAddtoCart.getAttribute('data-price-number')
        const buttonPrice = buttonAddtoCart.querySelector(".product-form__payment-container__price ");
        const firstLetter = this.querySelector(".loveletter-swatch");
        let clickedLetterPrice = 0;

        if (this.letterCount != 0) {
            clickedLetterPrice = parseInt(clickedLetter.querySelector('.loveletter-result__selection__letter').getAttribute('data-price'));
        }

        buttonPrice.textContent = ((startingPrice / 100) + this.letterCount * clickedLetterPrice) + "€";
    }
    async postForm(e) {
        const letterSelection = this.querySelector('.loveletter-result__selection');
        const selectedLetters = letterSelection.querySelectorAll(".loveletter-result__selection__letter");
        const mainId = document.querySelector('input[name="id"]').value;
        // Array to store additional products
        const items = [];
        const self = this;

        let loverLetterItem = {
            'id': parseInt(mainId),
            'quantity': 1,
            'sections': "mini-cart"
        };
        let loverLetterString = [];
        let loverLetterIds = [];
        // Append additional products to the array
        selectedLetters.forEach(selectedLetter => {
            const metaobjectId = selectedLetter.getAttribute('data-id'); // Assuming 'data-id' holds the ID of the metaobject
            const metaobjectLetter = selectedLetter.getAttribute('data-letter'); // Assuming 'data-id' holds the ID of the metaobject
            const quantity = 1; // Adjust the quantity as needed

            // Construct additional product object
            const additionalProduct = {
                id: parseInt(metaobjectId), // Ensure the ID is converted to a string
                quantity: quantity,
                properties: {
                    'hidden': 'true'
                },
                sections: "mini-cart"
            };

            // Push additional product to array
            items.push(additionalProduct);
            loverLetterString.push(metaobjectLetter);
            loverLetterIds.push(metaobjectId);
        });

        loverLetterItem.properties = {
            'cube_string': loverLetterString.join(),
            'cube_ids': loverLetterIds.join(','),
        };

        items.push(loverLetterItem);

        let formData = { 'items': items };

        fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(async response => {
                const cartContent = await response.json();
                console.log(cartContent);
                self.reloadMiniCart(cartContent, 4);
                // return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    reloadMiniCart(cartContent, quantity=0) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
                cart: cartContent,
            }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
                cart: cartContent,
                openMiniCart: true,
                replacementDelay: quantity === 0 ? 600 : 750
            }
        }));
    }

}

window.customElements.define("component-product-loveletter", ProductLoveLetter);

const minicartDetailToggle = document.querySelectorAll('.loveletter-details__toggle');

minicartDetailToggle.forEach((toggleEl) => {
    toggleEl.addEventListener("click", function (event) {
        const target = event.currentTarget;
        target.nextElementSibling.classList.toggle('active');
        target.classList.toggle('active');
    });
})
const minicartLoveletterItem = document.querySelectorAll('.line-item__loveletter');

minicartLoveletterItem.forEach((item) => {
    item.addEventListener("click", _onRemoveLoveletter);
})

async function _onRemoveLoveletter(e) {
    const target = e.currentTarget;
    const lettersInLoveletterElToRemove = [];
    const id = target.getAttribute('data-id');

    try {
        // Fetch cart data
        const response = await fetch('/cart.js');
        const data = await response.json();

        // Find the line item in the cart data with matching ID
        const lineItem = data.items.find(item => item.variant_id.toString() === id.toString());

        if (lineItem) {
            // Access properties of the line item
            const lettersToRemove = lineItem.properties.cube_ids.split(',');
            lettersInLoveletterElToRemove.push(lettersToRemove);
        } else {
            console.log('Line item not found in cart.');
        }
    } catch (error) {
        console.error('Error:', error);
    }
    lettersInLoveletterElToRemove.length > 0 ? _removeLettersFromCart(lettersInLoveletterElToRemove[0]) : null;
    async function _removeLettersFromCart(lettersInLoveletterElToRemove) {
        try {
            // Fetch cart data
            const response = await fetch('/cart.js');
            const data = await response.json();

            // Find the line items in the cart data whose ids match those in lettersInCartToRemove
            const lineItemsToRemove = data.items.filter(item => lettersInLoveletterElToRemove.includes(item.variant_id.toString()));

            // Construct an array of line item keys to remove
            const lineItemKeysToRemove = lineItemsToRemove.map(item => item.key);

            // If there are line items to remove, perform the removal
            if (lineItemKeysToRemove.length > 0) {

                const updates = {};
                lineItemKeysToRemove.forEach(key => {
                    updates[key] = 0;
                });


                const removeResponse = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: updates,
                    }),
                });

                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        openMiniCart: true,
                        replacementDelay: 750
                    }
                }));

            } else {
                console.log('No line items to remove.');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

}
